import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { get } from "../../../_helper/api_helper";

const sliceName = "vendor";

export const getVendors = createAsyncThunk(
    `${sliceName}/vendors`,
    async () => {
        try {
            let vendorList = [];
            try {
                const vendorData = await get(`${process.env.REACT_APP_API_URL_PR}vendor/GetAll`);
                vendorList = vendorData?.data || [];
            } catch (error) {
                return { vendorList: [] };
            }

            return { vendorList };
        } catch (e) {
            return {
                error: e.message,
                vendorList: {},
            };
        }
    }
);

export const fetchVendors = createAsyncThunk(
    `${sliceName}/fetchVendors`,
    async () => {
        try {
            const response = await get(`${process.env.REACT_APP_API_URL_PR}VendorRegistry/GetAll`);
            return { vendors: response?.data || [] };
        } catch (e) {
            return { error: e.message };
        }
    }
);

export const fetchVendorsWithDeductionCode = createAsyncThunk(
    `${sliceName}/fetchVendorsWithDeductionCode`,
    async () => {
        try {
            const response = await get(`${process.env.REACT_APP_API_URL_PR}VendorRegistry/GetVendorsListWithDeductionCodes`);
            return { vendors: response?.data || [] };
        } catch (e) {
            return { error: e.message };
        }
    }
);

const vendorReducer = createSlice({
    name: sliceName,
    initialState: {
        vendorList: [],
        vendors: [],
        vendorListWithDeductionCodes: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getVendors.pending, (state) => {
                state.loading = true;
            })
            .addCase(getVendors.fulfilled, (state, action) => {
                state.vendorList = action.payload.vendorList;
                state.loading = false;
            })
            .addCase(getVendors.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchVendors.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchVendors.fulfilled, (state, action) => {
                state.vendors = action.payload.vendors;
                state.loading = false;
            })
            .addCase(fetchVendors.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchVendorsWithDeductionCode.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchVendorsWithDeductionCode.fulfilled, (state, action) => {
                state.vendorListWithDeductionCodes = action.payload.vendors;
                state.loading = false;
            })
            .addCase(fetchVendorsWithDeductionCode.rejected, (state) => {
                state.loading = false;
            })
    },
});

export default vendorReducer.reducer;
